import { request } from '@bedrock-rdk/utils';
import { SINGLE_LINE_COMPONENTS, LISTS } from './staticFiles.constants';

const parseInlineBlock = block => {
  let content = '';

  block.children
    .filter(n => n.type === 'text' || n.type === 'hardbreak')
    .forEach(n => {
      content += n.type === 'hardbreak' ? '\n' : n.content;
    });

  return content;
};

const prepareEnbeddedList = blocks => {
  const getEmptyNode = () => ({ originalIndex: undefined, content: '' });
  const nodes = [];
  let node = getEmptyNode();
  blocks.forEach(block => {
    if (block.type === 'list_item_open') {
      node.originalIndex = block.info;
    } else if (block.type === 'list_item_close') {
      nodes.push(node);
      node = getEmptyNode();
    } else if (block.type === 'inline') {
      node.content = block.content;
    }
  });

  return nodes;
};

const prepareBlockValue = (type, blocks) => {
  const node = { tag: type };
  if (SINGLE_LINE_COMPONENTS.includes(type)) {
    node.content = '';
    const block = blocks[0];
    if (block.type === 'inline' && block.children) {
      node.content = parseInlineBlock(block);
    }
  } else if (LISTS.includes(type)) {
    node.content = [];
    node.content = prepareEnbeddedList(blocks);
  }

  return node;
};

export const filterNodes = (nodes, values = []) => {
  const openNode = nodes[0];
  const closeType = openNode.type.replace('_open', '_close');
  const closeNode = nodes.find(n => n.type === closeType);
  const stopIndex = nodes.indexOf(closeNode);
  const blockValue = nodes.slice(1, stopIndex);
  values.push(prepareBlockValue(openNode.tag, blockValue));
  const nextBlock = nodes.slice(stopIndex + 1);

  return nextBlock.length ? filterNodes(nextBlock, values) : values;
};

// NOTE: markdown-it is only needed by the static pages (terms, privacy, FAQ), so it is loaded on
// demand rather than parsed at every launch.
const loadMarkdownIt = () =>
  import(
    /* webpackChunkName: "vendor.markdown" */
    'markdown-it'
  ).then(module => module.default);

export const parseFile = url =>
  Promise.all([loadMarkdownIt(), request(url)]).then(([MarkdownIt, text]) => new MarkdownIt().parse(text));

export const renderHTML = url =>
  Promise.all([loadMarkdownIt(), request(url)]).then(([MarkdownIt, text]) => {
    const md = new MarkdownIt({ linkify: false });
    md.renderer.rules.link_open = () => '';
    md.renderer.rules.link_close = () => '';

    return md.render(text);
  });
